import _first from 'lodash/first';
import {SPECIAL_DIMENSION_BY_VIEW_BY} from '../analytics.constants';

import {DimensionValue} from '../analytics.types';

export default function getDimensionMainParameter(
  isUnique: boolean,
  dimension: DimensionValue,
): DimensionValue {
  return isUnique ? _first(SPECIAL_DIMENSION_BY_VIEW_BY[dimension]) : dimension;
}
